import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * SectionTabs — Tab-navigatie binnen een sectie
 *
 * Wordt direct onder de PageToolbar geplaatst.
 * Maximaal 5 tabs per sectie.
 * Slaat de laatst bezochte tab op in localStorage per sectie (terugkeergedrag).
 *
 * @param {Array} tabs - [{ label, href, testId? }]
 */
export const LAST_TAB_PREFIX = 'spk_last_tab_';

export const SectionTabs = ({ tabs }) => {
  const { pathname } = useLocation();

  // Terugkeergedrag: sla de actieve tab op in localStorage
  useEffect(() => {
    const section = pathname.split('/')[1]; // beoordelen, risicos, verbeteren, organisatie
    if (section) {
      const activeTab = tabs.find(t => pathname === t.href || (t.match && t.match.some(m => pathname.startsWith(m))));
      if (activeTab) {
        try {
          localStorage.setItem(`${LAST_TAB_PREFIX}${section}`, JSON.stringify({
            href: activeTab.href,
            label: activeTab.label,
            ts: Date.now(),
          }));
        } catch {}
      }
    }
  }, [pathname, tabs]);

  return (
    <div className="bg-white border-b border-[#E5E7EB] px-6" data-testid="section-tabs">
      <nav className="flex gap-1 -mb-px" aria-label="Sectie navigatie">
        {tabs.map((tab) => {
          const active = pathname === tab.href || (tab.match && tab.match.some(m => pathname.startsWith(m)));
          return (
            <Link
              key={tab.href}
              to={tab.href}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors ${
                active
                  ? 'border-[#111827] text-[#111827]'
                  : 'border-transparent text-[#6B7280] hover:text-[#111827] hover:border-[#D1D5DB]'
              }`}
              data-testid={tab.testId || `tab-${tab.label.toLowerCase().replace(/[^a-z0-9]/g, '-')}`}
            >
              {tab.label}
            </Link>
          );
        })}
      </nav>
    </div>
  );
};

/* ─── Sectie-definities ─── */
export const SECTIONS = {
  beoordelen: {
    label: 'Beoordelen',
    tabs: [
      { label: 'Nulmeting', href: '/beoordelen/nulmeting' },
      { label: 'Volwassenheid', href: '/beoordelen/volwassenheid' },
    ],
  },
  risicos: {
    label: "Risico's",
    tabs: [
      { label: "Risico's", href: '/risicos/overzicht', match: ['/risicos/overzicht', '/risks'] },
      { label: 'Kwetsbaarheden', href: '/risicos/kwetsbaarheden' },
      { label: 'Dreigingen', href: '/risicos/dreigingen' },
      { label: 'Systemen', href: '/risicos/systemen' },
    ],
  },
  verbeteren: {
    label: 'Verbeteren',
    tabs: [
      { label: 'Maatregelen', href: '/verbeteren/maatregelen' },
      { label: 'Strategie', href: '/verbeteren/strategie' },
      { label: 'Financieel', href: '/verbeteren/financieel' },
      { label: 'Leveranciers', href: '/verbeteren/leveranciers' },
    ],
  },
  organisatie: {
    label: 'Organisatie',
    tabs: [
      { label: 'Bedrijfsgegevens', href: '/organisatie/gegevens' },
      { label: 'Mensen & teams', href: '/organisatie/mensen' },
      { label: 'Verantwoordelijkheden', href: '/organisatie/verantwoordelijkheden' },
    ],
  },
};
